import { render } from "./ShowInstitution.vue?vue&type=template&id=d8973a68"
import script from "./ShowInstitution.vue?vue&type=script&lang=js"
export * from "./ShowInstitution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__